import { addChatToSpam, setChatOperationPending } from './actions';
import {
  fetchChatsMoveToSpamDesktop,
  TChatsMoveToSpamDesktopResponse,
} from '../../repositories/chats/v1/chats/move-to-spam-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { increaseCountClosedChats } from '../chatWindow';

/**
 * Пытаемся переместить чат в спам
 */
export const moveToSpam =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    dispatch(increaseCountClosedChats());

    dispatch(setChatOperationPending(true));

    try {
      const { statusCode, response }: TChatsMoveToSpamDesktopResponse = await fetchChatsMoveToSpamDesktop({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setChatOperationPending(false));

      // @ts-expect-error в модели response не хватает описания 204 ответа
      if (statusCode === 200 || statusCode === 204) {
        dispatch(addChatToSpam(chatId));

        /**
         * При успешном перемещении в спам, показываем алерт отмены
         */
        dispatch(showAlert({ type: EAlert.Spam }));

        return;
      }

      /**
       * При неудачной попытке перенести чат в спам, показываем алерт с ошибкой
       */
      dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке заблокировать чат' }));
    } catch (error) {
      const exception = getGenericLikeError({
        error,
        domain: EExceptionDomain.Chat,
        message: 'Ошибка при попытке перенести в спам',
      });

      logger.error(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/chats/move-to-spam-desktop/',
        parameters: JSON.stringify({ chatId }),
      });

      dispatch(setChatOperationPending(false));
      dispatch(showAlert({}));
    }
  };
